<div *ngIf="starting" class="main-preloader">
	<img
		class="preloader"
		alt="loader"
		src="/assets/images/preloaders/global_preloader.gif"
	/>
</div>

<section class="survey-page">
	<!-- Big Loader -->
	<div class="large-loader--wrapper" *ngIf="starting">
		<img
			class="svg-loader large-loader"
			alt="loader"
			src="/assets/images/preloaders/loading-icon.svg"
		/>
	</div>

	<app-reasons-modal
		*ngIf="!starting"
		[event]="event"
		(onSave)="goHome()"
		(onCancel)="goHome()"
		(onClose)="goHome()"
	></app-reasons-modal>
</section>
